import { ViewerContext } from "dash-ui";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthPagesLayout } from "v2/components/auth-pages-layout";
import { ConfirmMfaCodeForm } from "v2/components/auth/confirm-mfa-form";
import { EnableMfaForm } from "v2/components/auth/enable-mfa-form";

export function MfaConfirmationPage() {
  // Hooks
  const auth = useContext(ViewerContext);
  const navigate = useNavigate();

  // Redirect unauthenticated users
  useEffect(() => {
    if (!auth.account) navigate("/auth/sign-in");
  }, [auth]);

  // HTML Element
  return (
    <AuthPagesLayout>
      {!auth.account?.mfaEnabled && <EnableMfaForm />}
      {auth.account?.mfaEnabled && <ConfirmMfaCodeForm />}
    </AuthPagesLayout>
  );
}
